<template>
  <a v-if="!inScud" @click="sendScudXml($event, requireTransport)">
    <img :src="iconPath('v_scud.svg')" alt="" class="icon-pdf">
    {{ sendToScudText }}
  </a>
</template>

<script>
import mainMixin from '@/common/mixins/mainMixin'
import actionListMenuMixin from '@/common/mixins/actionListMenuMixin'

export default {
  name: 'SendToScudButton',

  mixins: [
    mainMixin,
    actionListMenuMixin
  ],

  props: {
    applicationId: Number,
    personalId: Number,
    transportId: Number,

    inScud: {
      type: Boolean,
      default: true
    },

    visitor: {
      type: Object,
      default: () => ({})
    },

    transportIndex: {
      type: Number,
      default: 0
    },

    requireTransport: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    sendToScudText() {
      return this.requireTransport ? 'Передать в СКУД (с ТС)' : 'Передать в СКУД (пешеходный)'
    }
  },

  methods: {
    iconPath(baseName) {
      return require('@/common/assets/img/icons/menuVisitor/' + baseName)
    }
  }
}
</script>

<style scoped>

</style>
